/**
 * Export chat messages to a JSON file
 * @param {Array} messages - Array of chat messages
 * @returns {void}
 */
export const exportChatMessages = messages => {
  try {
    if (!messages || messages.length === 0) {
      throw new Error("No messages available to export");
    }

    // Format messages for export
    const formattedMessages = messages.map(message => {
      const messageDate =
        message.time instanceof Date ? message.time : new Date(message.time);

      return {
        sender: message.senderName || "Anonymous",
        message: message.message || "",
        time: messageDate.toISOString(),
        // formattedTime: formatTimeForExport(messageDate),
        // type: getMessageType(message),
        // recipientRoles: message.recipientRoles || [],
        // recipientPeer: message.recipientPeer || null,
      };
    });

    const chatData = {
      exportedAt: new Date().toISOString(),
      totalMessages: formattedMessages.length,
      messages: formattedMessages,
    };

    const dataStr = JSON.stringify(chatData, null, 2);
    const dataBlob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `chat_export_${
      new Date().toISOString().split("T")[0]
    }.json`;
    link.style.display = "none";
    document.body.appendChild(link);

    // Use setTimeout to ensure the click happens in the event loop
    setTimeout(() => {
      try {
        link.click();
        // Clean up after a short delay to ensure download starts
        setTimeout(() => {
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        }, 100);
      } catch (clickError) {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        throw new Error(
          "Failed to trigger download. Please check your browser's download settings."
        );
      }
    }, 0);
  } catch (error) {
    console.error("Error exporting chat messages:", error);
    throw error;
  }
};

/**
 * Format time for export
 * @param {Date} date - Date object
 * @returns {string} Formatted time string
 */
// const formatTimeForExport = date => {
//   if (!(date instanceof Date)) {
//     return "";
//   }
//   const year = date.getFullYear();
//   const month = String(date.getMonth() + 1).padStart(2, "0");
//   const day = String(date.getDate()).padStart(2, "0");
//   let hours = date.getHours();
//   let mins = date.getMinutes();
//   let secs = date.getSeconds();
//   const suffix = hours > 11 ? "PM" : "AM";

//   if (hours > 12) {
//     hours = hours - 12;
//   } else if (hours === 0) {
//     hours = 12;
//   }

//   if (hours < 10) {
//     hours = "0" + hours;
//   }
//   if (mins < 10) {
//     mins = "0" + mins;
//   }
//   if (secs < 10) {
//     secs = "0" + secs;
//   }

//   return `${year}-${month}-${day} ${hours}:${mins}:${secs} ${suffix}`;
// };

/**
 * Get message type for export
 * @param {Object} message - Message object
 * @returns {string} Message type
 */
// const getMessageType = message => {
//   if (message.recipientRoles && message.recipientRoles.length > 0) {
//     return "role";
//   }
//   if (message.recipientPeer) {
//     return "private";
//   }
//   return "broadcast";
// };
